import { useState } from 'react';
import sampleUserImage from '@/assets/images/sample-user.png';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: '佐藤 美咲',
      role: '主婦',
      location: '東京都世田谷区',
      rating: 5,
      text: '実家の片付けをお願いしました。何十年も溜め込んだ荷物で足の踏み場もなかったのですが、スタッフの方々がテキパキと分別・搬出してくださり、2日で綺麗になりました。母も大変喜んでいます。',
      avatar: sampleUserImage
    },
    {
      name: '田中 健太',
      role: '会社員',
      location: '神奈川県横浜市',
      rating: 5,
      text: '急な転勤で退去しなければならず、不用品の処分に困っていました。電話した当日に見積もりに来てくださり、その週末には作業完了。スピーディーな対応に感謝しています。料金も他社より安かったです。',
      avatar: sampleUserImage
    },
    {
      name: '鈴木 陽子',
      role: '自営業',
      location: '埼玉県さいたま市',
      rating: 5,
      text: '遺品整理をお願いしました。ただ捨てるのではなく、一つ一つ丁寧に確認しながら仕分けてくださったのが印象的でした。探していた父の時計も見つけていただき、本当にありがとうございました。',
      avatar: sampleUserImage
    },
    {
      name: '高橋 誠',
      role: '大家',
      location: '千葉県船橋市',
      rating: 5,
      text: '管理物件で孤独死が発生し、特殊清掃をお願いしました。臭いが酷かったのですが、オゾン脱臭などの専門的な処理で完全に無臭になりました。近隣への配慮も素晴らしく、また何かあればお願いしたいです。',
      avatar: sampleUserImage
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-pink-50 via-white to-purple-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/20 border border-primary/30 px-4 py-2 rounded-full mb-4">
            <i className="ri-chat-quote-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">お客様の声</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ご利用いただいた <strong className="text-primary">皆様の感想</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            多くのお客様から喜びの声をいただいております。
          </p>
        </div>

        {/* Testimonial Slider */}
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-6xl mx-auto relative">
          {/* Left Arrow */}
          <button 
            onClick={prevTestimonial}
            className="absolute left-0 md:-left-16 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-all cursor-pointer border border-gray-200"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          {/* Testimonial Card */}
          <div className="w-full">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl border border-gray-100 min-h-[400px] flex flex-col justify-center">
              {/* Stars */}
              <div className="flex items-center justify-center gap-1 mb-6">
                {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-yellow-400"></i>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-lg md:text-xl text-gray-700 text-center mb-8 leading-relaxed italic">
                "{testimonials[activeIndex].text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-center gap-4">
                <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-primary">
                  <img 
                    src={testimonials[activeIndex].avatar}
                    alt={testimonials[activeIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-left">
                  <div className="font-bold text-gray-900 text-lg">{testimonials[activeIndex].name}</div>
                  <div className="text-gray-600 text-sm">{testimonials[activeIndex].role}</div>
                  <div className="text-primary text-sm flex items-center gap-1">
                    <i className="ri-map-pin-line"></i>
                    {testimonials[activeIndex].location}
                  </div>
                </div>
              </div>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                    index === activeIndex ? 'bg-primary w-8' : 'bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Right Arrow */}
          <button 
            onClick={nextTestimonial}
            className="absolute right-0 md:-right-16 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary hover:text-white transition-all cursor-pointer border border-gray-200"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">4.9/5</div>
            <div className="text-sm text-gray-600">平均評価</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">850+</div>
            <div className="text-sm text-gray-600">レビュー数</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">98%</div>
            <div className="text-sm text-gray-600">リピート・紹介率</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">5000+</div>
            <div className="text-sm text-gray-600">累計実績</div>
          </div>
        </div>
      </div>
    </section>
  );
}